<template>
  <div class="news-detail">
    <div class="news-menu">
      <el-menu
        :default-active="activeIndex"
        class="news-nav"
        mode="vertical"
        @select="handleSelect"
      >
        <el-menu-item v-for="(item, index) of newsList" :key="index" :index="String(item.id)">{{ item.title }}</el-menu-item>
      </el-menu>
    </div>
    <div class="news-content">
      <div class="article-list">
        <el-empty v-if="!loading && newsList.length === 0" description="暂无数据" />
        <el-skeleton v-else-if="loading" :rows="5" animated />
        <template v-else>
          <!-- 文章内容 -->
          <div class="article-content">
            <h1 class="title">{{ detail.title }}</h1>
            <div class="meta">
              <span class="time">{{ formatTime(detail.create_time) }}</span>
            </div>
            <div class="content" v-html="detail.content"></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { articleInfo, articleList } from '@/api/index'

export default {
  name: 'NewsDetail',
  data() {
    return {
      detail: {}, // 文章详情
      newsList: [], // 文章列表
      activeIndex: null, // 默认选中的菜单项索引
      loading: false, // 加载中
    }
  },
  created() {
    // 从路由参数中获取文章ID
    const id = this.$route.query.id
    if (id) {
      this.activeIndex = String(id)
      // 确保页面刷新时也能获取到导航和底部数据
      this.$store.dispatch('getHomeData').then(() => {
        this.getDetail(id)
      })
      this.getArticleList(this.$route.query.classify_id)
    }
  },
  methods: {
    getDetail(id) {
      if (!id) {
        this.$message.error('参数错误')
        return
      }
      articleInfo({id: id}).then(res => {
        this.detail = res.data
      })
    },
    formatTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    // 文章列表
    getArticleList(id) {
      articleList({
        classify_id: id
      }).then(res => {
        if (res.data.rows) {
          // 过滤掉 status 为 0 的数据
          this.newsList = res.data.rows.filter(item => item.status !== 0);
        } else {
          this.newsList = [];
        }
      })
    },

    handleSelect(key) {
      this.activeIndex = key;
      // this.getArticleList(key)
      this.getDetail(this.activeIndex)
    },
  }
}
</script>

<style lang="scss" scoped>
.news-detail {
  margin: 10px auto;
  display: flex;
  max-width: 1200px;
  min-height: calc(100vh - 60px);
  background-color: #fff;

  .news-menu {
    width: 200px;
    border-right: 1px solid #EBEEF5;

    .news-nav {
      border-right: none;

      .el-menu-item {
        height: 50px;
        line-height: 50px;
        padding: 0 15px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: all 0.3s;
        position: relative;

        &:hover {
          background-color: #f5f7fa;
          color: #409EFF;
        }

        &.is-active {
          color: #409EFF;
        }
      }
    }
  }

  .news-content {
    flex: 1;
    padding: 20px;
    overflow: hidden;

    .article-list {
      .news-item {
        display: flex;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid #EBEEF5;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background-color: #F5F7FA;
        }

        .item-img {
          width: 120px;
          height: 80px;
          margin-right: 20px;
          overflow: hidden;
          border-radius: 4px;

          .el-image {
            width: 100%;
            height: 100%;
          }
        }

        .item-content {
          flex: 1;
          position: relative;
          padding-right: 100px;

          h3 {
            margin: 0 0 10px;
            font-size: 16px;
            color: #303133;
          }

          p {
            margin: 0;
            color: #909399;
            font-size: 14px;
          }

          .item-date {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            text-align: center;
            color: #f56c6c;

            span {
              display: block;

              &:first-child {
                font-size: 24px;
                font-weight: bold;
              }

              &:last-child {
                font-size: 12px;
                margin-top: 5px;
              }
            }
          }
        }
      }

      .content-body {
        font-size: 14px;
        text-indent: 2em;

        .show-more {
          color: #409EFF;
          cursor: pointer;
          margin-left: 5px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .article-detail {
      padding: 20px;

      .detail-title {
        font-size: 24px;
        color: #303133;
        margin-bottom: 20px;
        text-align: center;
      }

      .detail-info {
        text-align: center;
        color: #909399;
        margin-bottom: 30px;

        .date {
          font-size: 14px;
        }
      }

      .detail-content {
        line-height: 1.8;
        color: #303133;
        font-size: 16px;

        :deep(img) {
          max-width: 100%;
          height: auto;
          margin: 10px 0;
        }
      }
    }
  }
}
</style>
